/* eslint-disable */
import Vue from 'vue'
import Axios from 'axios'
import i18n from '@/i18n'

let v = new Vue()

/**
 *
 * @param {*} params
 */
export const findPasswordSendCode = params => {
  return Vue.fetch.post('/apiv1/account/sendVerifyCode', params)
}

/**
 * 手机号登录
 * @param {*} params
 */
export const loginByPhone = params => {
  return Vue.fetch.post('/apiv1/account/bindLogin', params)
}
export const checkDeveloperEmail = params => {
  return Vue.fetch.post('/apiv1/account/checkDeveloperLoginName', params)
}
/**
 * 登录
 */
export const login = params => {
  return Vue.fetch.post('/apiv1/account/login', params, undefined, false)
}

export const createCompany = params => {
  return Vue.fetch.post('/apiv1/hr/company/addCompany', params)
}

/**
 *
 */
export const getAppCom = () => {
  return Vue.fetch.post('/apiv1/pioneer/app/findAppInfoSelect')
}
/**
 * 获取验证码
 * @param {*} params
 */
export const getShowCode = () => {
  return Vue.fetch.post('/apiv1/account/showCode')
}
/**
 * 开发者注册发送邮箱验证码
 */
export const sendRegisterMail = params => {
  return Vue.fetch.post('/apiv1/pioneer/app/sendRegisterVerifyCode', params)
}

/**
 * 获取邮件的验证码
 */
export const getEmailCode = params => {
  return Vue.fetch.post('/apiv1/account/verifyCode', params)
}

/**
 * 注册
 */
export const toRegister = params => {
  return Vue.fetch.post('/apiv1/account/addDeveloper', params)
}
/**
 * 退出登录
 */
export const loginout = params => {
  return Vue.fetch.post('/apiv1/account/loginout', params)
}

export const loginFree = params => {
  return Vue.fetch.post('/apiv1/account/autoLogin', params, undefined, false)
}

export const findCompanyDetails = params => {
  return Vue.fetch.post('/apiv1/hr/company/findCompanyDetails', params)
}

export const sendMail = params => {
  return Vue.fetch.post('/apiv1/account/sendMail', params)
}

export const findPassword = params => {
  return Vue.fetch.post('/apiv1/account/findPassword', params)
}

export const verifyCode = params => {
  return Vue.fetch.post('/apiv1/account/verifyCode', params)
}

const message = {
  lang: 'zh-CN',
  sessionId: null,
  payload: {
    params: {}
  }
}

export const checkoutSession = () => {
  return new Promise((resolve, reject) => {
    Axios.post('/apiv1/auth/sessionTest', message, {})
      .then(data => {
        if (data.data.code === '300' || data.data.code === 'E0010000') {
          resolve(data.data)
        } else {
          reject(data.data)
        }
      })
      .catch(data => {
        v.$alert(
          i18n.t('common.sessionTimeOut'),
          i18n.t('common.warningNotice'),
          {
            confirmButtonText: i18n.t('common.yes'),
            showClose: false,
            callback: action => {
              sessionStorage.removeItem('isLogin')
              sessionStorage.removeItem('loginInfo')
              sessionStorage.removeItem('loginName')
              sessionStorage.removeItem('companyId')
              sessionStorage.removeItem('companyCode')
              sessionStorage.removeItem('role')
              sessionStorage.removeItem('appKey')
              window.vm.appKey = ''
              window.location.href = '/'
            }
          }
        )
      })
  })
}



// WEBPACK FOOTER //
// ./src/services/acountApi.js